import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { logInWithEmailAndPassword } from "../../../firebaseHelper";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
var CryptoJS = require("crypto-js");
/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

function LoginSSO(props) {
  var url = window.location.href;
  var creptedUserName0 = url.split("username=")[1];
  var creptedUserName = creptedUserName0.split("&passwor")[0];
  var creptedPassword = url.split("password=")[1];
  const { t } = useTranslation();

  if (creptedUserName !== null && creptedUserName !== "null" && creptedUserName !== undefined) {
    Swal.fire({
      title: "SSO Authentication",
      html: "I will close automatically after authenticated",
      timer: 2000,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const p1 = new Promise(async (resolve, reject) => {
      var userNameDecrypt = CryptoJS.AES.decrypt(creptedUserName, "eMpower DLS 10 06 22");
      var passwordDecrypt = CryptoJS.AES.decrypt(creptedPassword, "eMpower DLS 10 06 22");
          
      var userName = userNameDecrypt.toString(CryptoJS.enc.Utf8);
      var password = passwordDecrypt.toString(CryptoJS.enc.Utf8);
      await resolve(
        login(userName, password)
          .then(async ({ data: { accessToken } }) => {
            props.login(accessToken);
            await logInWithEmailAndPassword(
              userName,
              `pass-${userName?.replace(" ", "")}`
            );
            return true;
          })

          .catch(() => {
            return false;
          })
      );
    });
    p1.then(
      (value) => {
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_SsoEmpowerURL;
        }, 300);
      },
      (reason) => {
        console.error(reason); // Error!
      }
    );
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shipper | {t("Login")}</title>
      </Helmet>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(LoginSSO));
